module.exports = {"371371001":"罗西街道","371371100":"马厂湖镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/371371.json
// module id = 1587
// module chunks = 0